﻿import Vue from "vue";
import Component from "vue-class-component"
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import { IHotEditableFormParentVue } from "../../common";
import common = require("../../common");
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");

// The @Component decorator indicates the class is a Vue component
@Component
class DonneesReferentiellesVue extends Vue implements IHotEditableFormParentVue {

    $initialData: any;

    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;
    isVisibleToggleButton = false;

    // Fonction système exécutée automatiquement AVANT le constructeur (!!!)
    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;

        HotEditableFormLoader.prepareComponentsMarkupFromTarget(true, false, rootId).loadComponentsFromParent(this);

        this.$options.el = '#' + rootId

        this.formManager = new HotEditableFormManager(this);
        this.shared = new SharedHotEditableParentForm(this.formManager);
    }

    // Fonction système exécutée automatiquement lorsque la composante Vue est créée
    created() { }

    // Fonction système exécutée automatiquement lorsque la composante Vue est montée
    mounted() {
    }
}

export = DonneesReferentiellesVue;